import { usePrivacy } from '../hooks/usePrivacy'

export default function PrivateValue({ children, placeholder = '•••••' }) {
  const { privacyMode } = usePrivacy()

  if (privacyMode) {
    return <span className="select-none">{placeholder}</span>
  }

  return <span data-preserve-color>{children}</span>
}
